export default __webpack_public_path__ + "static/hero-5496fcfdce00a603ed8be1e8e4d7d0c3.png";